//@ts-check
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

var styles = function styles() {
  return {
    root: {
      flexGrow: 1,
      position: 'fixed',
      bottom: 0,
      right: 18,
      //scroll-bar
      backgroundColor: '#ddd',
      zIndex: 1
    }
  };
};
/**
 * @param {import('./types').FloatingToolbarProps & import('@material-ui/core').WithStyles<typeof styles>} props
 */


function FloatingToolbar(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return React.createElement("div", {
    className: classes.root
  }, React.createElement(Grid, {
    spacing: 0,
    container: true,
    direction: "row",
    justify: "space-between",
    align: "stretch"
  }, children));
}

export default withStyles(styles, {
  name: 'ECFloatingToolbar'
})(FloatingToolbar);